/**
 * Runtime configuration of the staff console, read from Vite's `VITE_*` variables at build time
 * (`apps/staff/.env` for dev; the hosting pipeline sets them per environment).
 */
export const config = {
  apiUrl: import.meta.env.VITE_API_URL as string,
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
  },
  /**
   * Where the school app lives; act-as opens it there.
   */
  schoolAppUrl: (import.meta.env.VITE_SCHOOL_APP_URL as string).replace(/\/$/, ''),
  /**
   * Error reporting; empty DSN means off (the operator creates the Sentry projects, #8).
   */
  sentry: {
    dsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? '',
    release: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'local',
    environment: (import.meta.env.VITE_ENVIRONMENT as string | undefined) ?? 'local',
  },
} as const;

for (const [key, value] of Object.entries({
  VITE_API_URL: config.apiUrl,
  VITE_COGNITO_USER_POOL_ID: config.cognito.userPoolId,
  VITE_COGNITO_CLIENT_ID: config.cognito.clientId,
  VITE_SCHOOL_APP_URL: config.schoolAppUrl,
})) {
  if (!value) {
    throw new Error(`Missing ${key}: add it to apps/staff/.env or the build environment`);
  }
}
